module.exports = __webpack_public_path__ + "media/images/download/e-book05-6aac22069bddb25565caed653d1a0bac.png";